import React from "react";
import GroupSetting from "Components/GroupSetting/";
import useGroupSetting from "Hooks/useGroupSetting";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

export default function CreateGroup(props) {
  const auth = useAuth();
  
  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id);
  }, [props.location.pathname]);

  const groupSetting = useGroupSetting();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 収集グループ登録";

    groupSetting.initialData();
  }, []);

  const handleSubmit = async () => {
    try {
      await groupSetting.submit();
      props.history.push("/group?create=success");
    } catch (error) {}
  };

  return (
    <GroupSetting handleSubmit={handleSubmit} state={groupSetting.state} />
  );
}
